import { Link } from "react-router-dom";
import { I } from "@/components/Icon";

export type Crumb = {
  label: string;
  to?: string;
  // For in-page navigation that isn't a route (e.g. clearing a drill-in
  // state). Rendered as a clickable span; ignored on the last crumb.
  onClick?: () => void;
};

/**
 * Simple breadcrumb trail above the page title. Last crumb is the
 * current page (not linked). Separator: chevron glyph.
 *
 * Appearance follows the muted topbar aesthetic — small, uppercase,
 * tabular-spaced. Lives inside `.content` above the page head.
 */
export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav
      className="row"
      style={{
        gap: 6,
        marginBottom: 8,
        fontSize: 12,
        color: "var(--c-text-3)",
        letterSpacing: "0.02em",
      }}
    >
      {items.map((c, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            {c.to && !isLast ? (
              <Link
                to={c.to}
                style={{
                  color: "var(--c-text-3)",
                  borderBottom: "1px dashed transparent",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "var(--c-accent-600)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "var(--c-text-3)";
                }}
              >
                {c.label}
              </Link>
            ) : c.onClick && !isLast ? (
              <button
                type="button"
                onClick={c.onClick}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  font: "inherit",
                  letterSpacing: "inherit",
                  color: "var(--c-text-3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "var(--c-accent-600)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "var(--c-text-3)";
                }}
              >
                {c.label}
              </button>
            ) : (
              <span style={{ color: isLast ? "var(--c-text)" : "var(--c-text-3)" }}>
                {c.label}
              </span>
            )}
            {!isLast && (
              <span
                style={{
                  display: "inline-flex",
                  color: "var(--c-text-4)",
                  width: 10,
                  height: 10,
                }}
              >
                {I.chevron}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
